import { useField, useFormikContext } from 'formik';
import React from 'react';
import { DurationPicker } from '../../Components/DurationPicker/DurationPicker';
import { FormikTextField } from '../../Components/FormikFields/FormikTextField';
import { TimeUnits } from '../../Config/MedicationConfig';
import { numberGreaterThanZeroInputFilter } from '../../Shared/InputFilters';
import { CreateMedicationListForm } from '../CreateMedicationListDialog/CreateMedicationListDialog';
import styles from './MedicationListDefaultOverride.module.scss';
import { MedicationListDefaultOverrideSection } from './MedicationListDefaultOverrideSection';

export type DefaultDuration = {
    timeUnits: TimeUnits;
    number: string;
};

export type MedicationListDefaultOverrideStepState = {
    defaultDuration: DefaultDuration;
    defaultDosageInstructions: string;
    defaultDurationOverridden: boolean;
    defaultDosageInstructionsOverridden: boolean;
    defaultPackAmount: string;
    defaultPackAmountOverridden: boolean;
};

export const MedicationListDefaultOverride = () => {
    const form = useFormikContext<MedicationListDefaultOverrideStepState>();
    const [field, meta, helpers] = useField<CreateMedicationListForm>('defaultDuration');

    const defaultDurationError = meta.touched ? meta.error : '';

    return (
        <div className={styles.container}>
            <MedicationListDefaultOverrideSection
                field='defaultPackAmountOverridden'
                title='Change default number of packs'
            >
                <div className={styles.packAmount}>
                    <FormikTextField
                        label='No. of packs'
                        filterFunction={numberGreaterThanZeroInputFilter}
                        required
                        name='defaultPackAmount'
                        testId='pack-amount-default'
                        onChange={() => {
                            form.setFieldError('defaultPackAmount', '');
                        }}
                    />
                </div>
            </MedicationListDefaultOverrideSection>
            <MedicationListDefaultOverrideSection
                field='defaultDurationOverridden'
                title='Change default course duration'
            >
                <DurationPicker
                    timeLength={form.values.defaultDuration}
                    testId='duration-picker'
                    required
                    onUpdateTimeLength={value => {
                        form.setFieldValue('defaultDuration', value);
                        form.setFieldError('defaultDuration', '');
                        form.setFieldTouched('defaultDuration', true, false);
                    }}
                    error={defaultDurationError}
                />
            </MedicationListDefaultOverrideSection>
            <MedicationListDefaultOverrideSection
                field='defaultDosageInstructionsOverridden'
                title='Change default dosage instructions'
            >
                <FormikTextField
                    label='Dosage instructions'
                    required
                    name='defaultDosageInstructions'
                    testId='dosage-instructions-default'
                    maxLength={250}
                    onChange={() => {
                        form.setFieldError('defaultDosageInstructions', '');
                    }}
                />
            </MedicationListDefaultOverrideSection>
        </div>
    );
};
